import api from "../../services/api";

const useFiliais = (lead) => {
    if (!lead) {
        return { findAll: async () => [] };
    }
	const findAll = async () => {
        const { data } = await api.get(`/filiais/${lead}`);
        return data;
    }

	return { findAll };
};

export default useFiliais;
